module.exports = __webpack_public_path__ + "img/vacunas8.124d199a.jpg";